import { HelpCircle } from "lucide-react";
import { SupportArticleListBase, type Article } from "@core/features/support";
import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";
import { twMerge } from "tailwind-merge";

export type Props = {
  title: string;
  articles: Article[];
  onOpenArticle: (article: Article) => void;
  /** Additional className for styling */
  className?: string;
};

export function SupportArticleList({
  title,
  articles,
  onOpenArticle = () => {},
  className,
}: Props) {
  return (
    <SupportArticleListBase
      title={title}
      articles={articles}
      onArticleClick={onOpenArticle}
      className={twMerge("flex flex-col flex-1 gap-6 w-full", className)}
      renderTitle={(titleText) => <Type variant="h5">{titleText}</Type>}
      renderArticle={({ article, onClick }) => (
        <Button
          iconComponent={HelpCircle}
          variant="link-light"
          className="items-start justify-start p-0 whitespace-normal break-words text-brand-700 hover:text-brand-800"
          onClick={onClick}
          data-testid={`support-article-list-${article.slug}`}
        >
          {article.title}
        </Button>
      )}
      renderEmpty={() => (
        <Type variant="body2" className="text-brand-700">
          No articles found
        </Type>
      )}
    />
  );
}

export default SupportArticleList;

